module.exports = __webpack_public_path__ + "img/header-back-entry-user.6b0c3bfe.png";